module.exports = __webpack_public_path__ + "img/gwas_bmi_gwas.3414bc64.png";